<template>
  <div class="flex flex-col md:flex-row">
    <RevCard
      class="mr-[0.1rem] flex grow items-start rounded-b-none p-5 md:rounded-b-lg md:rounded-r-none md:p-7"
    >
      <RevSkeleton
        class="mr-4 hidden md:block"
        height="4.8rem"
        shape="rectangle"
        width="4.8rem"
      />
      <div class="flex flex-col">
        <RevSkeleton height="1.2rem" shape="rectangle" width="52.8rem" />
        <div class="mt-5 flex flex-col md:flex-row">
          <RevSkeleton height="1.2rem" shape="rectangle" width="12.4rem" />
          <RevSkeleton
            class="mt-5 md:ml-6 md:mt-0"
            height="1.2rem"
            shape="rectangle"
            width="13.3rem"
          />
          <RevSkeleton
            class="mt-5 md:ml-6 md:mt-0"
            height="1.2rem"
            shape="rectangle"
            width="9.4rem"
          />
        </div>
        <div class="mt-3 flex">
          <RevSkeleton height="1.2rem" shape="rectangle" width="12.4rem" />
          <div class="flex flex-col md:flex-row">
            <RevSkeleton
              class="ml-6"
              height="1.2rem"
              shape="rectangle"
              width="14.2rem"
            />
            <RevSkeleton
              class="ml-6 mt-4 md:mt-0"
              height="1.2rem"
              shape="rectangle"
              width="13.3rem"
            />
          </div>
        </div>
      </div>
    </RevCard>
    <RevCard
      class="border-static-default-mid flex items-center rounded-t-none border-t-2 p-5 md:rounded-tr-lg md:w-9 md:justify-center md:rounded-l-none md:border-t-0 md:p-0"
    >
      <RevSkeleton
        class="md:hidden"
        height="1.2rem"
        shape="rectangle"
        width="13.3rem"
      />
      <RevSkeleton
        class="hidden md:block"
        height="4rem"
        shape="circle"
        width="4rem"
      />
    </RevCard>
  </div>
</template>

<script setup lang="ts">
import { RevCard } from '@ds/components/Card'
import { RevSkeleton } from '@ds/components/Skeleton'
</script>
